import React from 'react'
import PropTypes from 'prop-types'
import { PageTitle, WithPageTitle } from '@morningtrain/react-app'
import { Translation, useTranslation } from '@morningtrain/react-translations'
import { PrimaryHeading } from 'ui/headings'

export default function TranslatedTitle (props) {
  const { data, count, name, defaultValue } = props
  const options = {
    data: data,
    count: count
  }

  const title = useTranslation(name, options, defaultValue)

  return (
    <>
      <WithPageTitle title={title} />
      <PageTitle />
    </>
  )
}

TranslatedTitle.defaultProps = {
  ...Translation.defaultProps,
  name: 'title'
}

TranslatedTitle.propTypes = {
  ...Translation.propTypes
}
